/* Only expiry protection. No API, account or price data requests. */
(() => {
  if (customElements.get('knapkon-reference-price')) return;
  class KnapkonReferencePrice extends HTMLElement {
    connectedCallback() {
      this.checkExpiry = () => {
        clearTimeout(this.expiryTimer);
        const remaining = Number(this.dataset.expires) * 1000 - Date.now();
        if (!Number.isFinite(remaining) || remaining <= 0 || remaining > 1800000) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.expiryTimer = setTimeout(this.checkExpiry, remaining + 20);
      };
      this.checkExpiry();
      document.addEventListener('visibilitychange', this.checkExpiry);
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.checkExpiry);
    }
  }
  customElements.define('knapkon-reference-price', KnapkonReferencePrice);
})();
